// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Antarctica from '../_raw/flag/icon_flag_antarctica.png';

export default () => <img src={Antarctica} alt="Antarctica" />;
